import { useEffect, useState } from "react";
import pages from "../constants/pages";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { signInMember } from "../redux/slices/memberSlice";
import useAxios from "./useAxios";

function useAuthRedirect() {
  const axios = useAxios();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [authStatus, setAuthStatus] = useState({
    isLoading: true,
    isComplete: false,
    error: null,
  });

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        setAuthStatus({ isLoading: true, isComplete: false, error: null });

        const popup = new URLSearchParams(location.search).get("popup");
        const isLoginPage = location.pathname.includes("/sign-in");
        const isLoginOTP = new URLSearchParams(location.search).get(
          "login_otp"
        );
        const visitorID = new URLSearchParams(location.search).get("visitorId");
        const visitor_id = new URLSearchParams(location.search).get(
          "visitor_id"
        );

        const mobileNo = new URLSearchParams(location.search).get("mobile_no");

        if (
          isLoginOTP &&
          mobileNo &&
          localStorage.getItem("visitorDataID") != (visitor_id || visitorID)
        ) {
          sessionStorage.clear();
          localStorage.clear();
        }
        console.log(
          localStorage.getItem("visitorDataID"),
          visitor_id,
          visitorID
        );

        // if (
        //   localStorage.getItem("visitorDataID") != (visitor_id || visitorID)
        // ) {
        //   sessionStorage.clear();
        //   localStorage.clear();
        // }

        const token =
          sessionStorage.getItem("authToken") ||
          localStorage.getItem("authToken");

        if (isLoginOTP && mobileNo) {
          const response = await axios({
            url: `event/booking/verify-otp?mobile_no=${mobileNo}&otp=${isLoginOTP}&is_mobile_number_required=false`,
            method: "POST",
            disableRedirect: true,
          });

          if (response.status) {
            await dispatch(
              signInMember({
                authToken: response.data.auth_token,
                ID: response.data._id,
              })
            );
            localStorage.setItem("mobileNumber", "91" + mobileNo);
            setAuthStatus({ isLoading: false, isComplete: true, error: null });
          } else {
            setAuthStatus({
              isLoading: false,
              isComplete: false,
              error: "Authentication failed",
            });
            navigate("/error");
          }
        } else if (
          !token &&
          !popup &&
          !isLoginPage &&
          !isLoginOTP &&
          !mobileNo
        ) {
          // navigate(pages.appointment.route);
          setAuthStatus({ isLoading: false, isComplete: true, error: null });
        } else if (token) {
          await dispatch(
            signInMember({
              authToken: token,
            })
          );
          setAuthStatus({ isLoading: false, isComplete: true, error: null });
        } else {
          setAuthStatus({ isLoading: false, isComplete: true, error: null });
        }
      } catch (error) {
        console.error("Error during authentication:", error);
        setAuthStatus({
          isLoading: false,
          isComplete: false,
          error: error.message,
        });
      }
    };

    authenticateUser();
  }, []);

  return authStatus;
}

export default useAuthRedirect;
